function isIE() {
  const ua = window.navigator.userAgent;
  const msie = ua.indexOf('MSIE ');
  const trident = ua.indexOf('Trident/');

  return (msie > 0 || trident > 0);
}

if (isIE()) {
  window.location.href = `${window.location.protocol}//${window.location.host}/browser-support.html`;
}

import Vue from 'vue';
import VueRouter from 'vue-router';
import VueI18n from 'vue-i18n';
import axios from 'axios';
import VueAxios from 'vue-axios';
import BootstrapVue from 'bootstrap-vue';
import Loading from 'vue-loading-overlay';
import vueHeadful from 'vue-headful';
import VueMoment from 'vue-moment';
import VueMeta from 'vue-meta';
import moment from 'moment-timezone';
import VueLazyload from 'vue-lazyload';
import VueCurrencyFilter from 'vue-currency-filter';
import VueTruncate from 'vue-truncate-filter';
import VModal from 'vue-js-modal';
import VueCountdown from '@chenfengyuan/vue-countdown';
import SocialSharing from 'vue-social-sharing';
import VueAuthenticate from 'vue-authenticate';
import VueAnalytics from 'vue-analytics';
import _ from 'lodash';

import fontInstaller from './plugins/font-installer';

import {library} from '@fortawesome/fontawesome-svg-core';
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {faFacebookF} from '@fortawesome/free-brands-svg-icons';
import {faGoogle} from '@fortawesome/free-brands-svg-icons';
import {faLinkedin} from '@fortawesome/free-brands-svg-icons';
import {faPinterest} from '@fortawesome/free-brands-svg-icons';
import {faReddit} from '@fortawesome/free-brands-svg-icons';
import {faTwitter} from '@fortawesome/free-brands-svg-icons';
import {faVk} from '@fortawesome/free-brands-svg-icons';
import {faWeibo} from '@fortawesome/free-brands-svg-icons';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';

library.add(faFacebookF);
library.add(faGoogle);
library.add(faLinkedin);
library.add(faPinterest);
library.add(faReddit);
library.add(faTwitter);
library.add(faVk);
library.add(faWeibo);
library.add(faWhatsapp);

import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';

import 'vue-loading-overlay/dist/vue-loading.css';
import 'slick-carousel/slick/slick.css';

import {socialProviders} from './plugins/social-providers';

const loadedLanguages = [];
const originalPush = VueRouter.prototype.push;

VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};

VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve,
      onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.prototype._ = _;

Vue.use(VueRouter);
Vue.use(VueI18n);
Vue.use(VueAxios, axios);
Vue.use(BootstrapVue);
Vue.use(Loading);
Vue.use(VueLazyload);
Vue.use(VueTruncate);
Vue.use(SocialSharing);
Vue.use(VueMeta);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueAuthenticate, {
  baseUrl: `${window.location.protocol}//${window.location.host}`,
  providers: socialProviders,
});

Vue.component('vue-headful', vueHeadful);
Vue.component('vue-loading', Loading);
Vue.component(VueCountdown.name, VueCountdown);
Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.config.productionTip = false;

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_DSN,
    ignoreErrors: [
      'Network Error',
      'Network failed',
      'Request aborted',
      'timeout of 0ms exceeded',
    ],
    integrations: [
      new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
  });
}

window.$ = window.jQuery = require('jquery');
window._ = require('lodash');
window.axios = axios;
window.axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
window.axios.defaults.headers['X-Auth-Token'] = '';

function getHostName() {
  let host = '';

  if (process.env.NODE_ENV !== 'development') {
    host = window.location.host;
  } else {
    host = process.env.VUE_APP_TEST_SHOP_ID || '04-platinum';
  }

  return host;
}

function renderMessage(message) {
  document.getElementsByTagName('html')[0].style.height = '100%';
  document.body.style.height = '100%';

  const wrapper = document.createElement('div');
  const app = document.getElementById('app');
  const node = document.createElement('p');
  const text = document.createTextNode(message);

  wrapper.style.width = '100%';
  wrapper.style.fontFamily = 'sans-serif';
  wrapper.style.fontWeight = 'bold';
  wrapper.style.textAlign = 'center';

  app.style.display = 'flex';
  app.style.justifyContent = 'center';
  app.style.alignItems = 'center';
  app.style.height = '100%';

  node.appendChild(text);
  wrapper.appendChild(node);
  app.appendChild(wrapper);

  return false;
}

const errorServerMessage = 'Error: The server isn\'t responding.';
const host = getHostName();
const loader = Vue.$loading.show({opacity: 1});

Vue.axios.post('shops/get_by_name', {host}).then(response => {
  loader.hide();

  if (response.data.data) {
    const coreParams = response.data.data;

    if (!response.data.success && response.data.message) {
      return renderMessage(`Error: ${response.data.message}`);
    }

    coreParams.theme_name = 'default';

    document.documentElement.style.fontSize = coreParams.theme_settings.font_size;

    const fontInstall = new fontInstaller();
    fontInstall.set(coreParams.theme_settings.typography);

    if (coreParams) {
      localStorage.shop = JSON.stringify(coreParams);
    }

    let availableLocales = [];

    if (!+coreParams.multi_language) {
      availableLocales.push({
        iso: coreParams.default_locale,
        name: coreParams.locales[coreParams.default_locale],
      });
    } else {
      for (const iso in coreParams.locales) {
        availableLocales.push({iso, name: coreParams.locales[iso]});
      }
    }

    if (!localStorage.lang) {
      localStorage.lang = coreParams.default_locale;
    } else if (!_.find(availableLocales, {iso: localStorage.lang})) {
      localStorage.lang = coreParams.default_locale;
    }

    if (availableLocales.length > 0) {
      availableLocales = _.sortBy(availableLocales, [(o) => o.name]);
    }

    Vue.prototype.availableLocales = availableLocales;

    const i18n = require('./plugins/i18n').i18n;
    const router = require('./router').router;
    const store = require('./store').store;

    const App = require('./App.vue').default;

    require('./mixins/global/core');
    require('./mixins/global/properties');
    require('./mixins/global/titles');
    require('./mixins/global/i18n');
    require('./mixins/global/auth');
    require('./mixins/global/toast');
    require('./mixins/global/favorites');
    require('./mixins/global/cart');
    require('./mixins/global/checkout');
    require('./mixins/global/order');
    require('./mixins/global/private-items');
    require('./mixins/global/coupons');
    require('./mixins/global/modal');

    const setI18nLanguage = lang => {
      window.axios.defaults.headers['X-lang'] = lang;
      window.axios.defaults.headers['X-lang2'] = lang;

      i18n.locale = localStorage.lang = lang;

      return lang;
    };

    const loadLanguageAsync = lang => {
      if (loadedLanguages.includes(lang)) {
        return Promise.resolve(setI18nLanguage(lang));
      }

      return axios.get(`${process.env.VUE_APP_I18N_URL}${lang}.json`).
          then((response) => {
            i18n.setLocaleMessage(lang, response && response.data ? response.data : {});
            loadedLanguages.push(lang);

            return setI18nLanguage(lang);
          });
    };

    router.beforeEach((to, from, next) => {
      // store.dispatch('SHOW_SIDEBAR', false);
      store.dispatch('SET_PREV_ROUTE', from);

      const lang = to.params.lang || localStorage.lang ||
          process.env.VUE_APP_I18N_LOCALE || 'en';

      if (!_.find(availableLocales, {iso: lang})) {
        if (to.redirectedFrom) {
          router.push(`/${i18n.locale}${to.redirectedFrom}`).catch(() => {});
        } else {
          router.push(`/${i18n.locale}/404`).catch(() => {});
        }
      } else {
        loadLanguageAsync(lang).then(() => next());
      }
    });

    const googleAnalyticsIds = ['UA-54331197-3'];

    if (coreParams.google_analytics_id !== '') {
      googleAnalyticsIds.push(coreParams.google_analytics_id)
    }

    Vue.use(VueAnalytics, {
      id: googleAnalyticsIds,
      set: [
          {field: 'anonymizeIp', value: true},
      ],
      router,
    });

    Vue.use(VModal, {
      dynamic: true,
      injectModalsContainer: true,
    });

    Vue.use(VueCurrencyFilter, {
      symbol: '€',
      thousandsSeparator: '.',
      fractionCount: 2,
      fractionSeparator: ',',
      symbolPosition: 'front',
      symbolSpacing: true,
    });

    new Vue({
      router,
      store,
      i18n,
      render: h => h(App),
    }).$mount('#app');
  } else {
    return renderMessage(errorServerMessage);
  }
}).catch(e => {
  // eslint-disable-next-line no-console
  console.log(e);
  loader.hide();

  return renderMessage(errorServerMessage);
});
